<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div>
      <header>
        <h3 class="text-brand fw-normal" tabindex="-1" #heading>
          {{convert('sellModule.offers.accept.textAcceptOffer')}}
        </h3>
      </header>
      <div id="disclosures">
        <p [innerHTML]="convert('sellModule.offers.accept.textSelectingAccept', {title : title})"></p>
      </div>
      <div class="mb-4">
        <app-datalist-item
          class="mb-4"
          label="{{convert('sellModule.offers.common.labelBuyerOffer')}}"
          [value]="get('amount', false) ? formatCurrency(get('amount', false)) : 'N/A'"
        ></app-datalist-item>
      </div>
      <div class="mb-4">
        <app-datalist-item class="mb-4" label="{{convert('sellModule.offers.common.labelBuyerComment')}}" [value]="offer.comment || 'N/A'"></app-datalist-item>
      </div>
      <form [formGroup]="commentForm">
        <div class="d-flex flex-column app-textarea">
          <div class="form-group mb-0">
            <label class="d-block text-start" for="accept-offer-comment">{{convert('sellModule.offers.common.labelComment')}}</label>
            <textarea
              id="accept-offer-comment"
              class="form-control mb-1"
              rows="3"
              maxlength="150"
              appCharacterCount
              #comment="appCharacterCount"
              [class.invalid-input]="localErrorMessage"
              (keyup)="replaceInvalidCharacters($event)"
            ></textarea>
            <app-character-count
              [count]="comment.count$ | async"
              [maxLength]="150"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
            <div class="error-message" aria-live="polite" tabindex="-1">
              @if (localErrorMessage) {
                <strong>{{localErrorMessage}}<br /></strong>
              }
            </div>
          </div>
        </div>
      </form>
      <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
        <button
          class="btn btn-primary"
          type="submit"
          data-track-elem="button"
          [attr.data-track-name]="'Accept-' + inventoryItem.inventoryItemUuid"
          data-track-trigger="modal"
          [attr.data-track-region]="offer.dealershipName"
          [attr.data-track-id]="inventoryItem.inventoryItemUuid"
          (click)="accept()"
          [attr.aria-label]="convert('sellModule.offers.accept.ariaLabelAcceptOffer')"
          >
          {{convert('sellModule.offers.accept.btnAccept')}}
        </button>
        <button
          class="ms-lg-2 mt-2 mt-lg-0 btn"
          type="button"
          [ngClass]="'btn btn-link'"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          [attr.aria-label]="convert('sellModule.offers.accept.ariaLabelCancelAcceptOffer')"
          (click)="cancel.emit()"
          >
          <span>{{convert('common.btnCancel')}}</span>
        </button>
      </div>
    </div>
  }


  <app-modal [modalId]="modalId" >
    <header class="modal__header">
      <h1 class="modal__title" tabindex="-1">
        {{convert('sellModule.offers.accept.textAreSure')}}
      </h1>
    </header>
    <div class="modal__content">
      <p [innerHTML]="messageWarningText"></p>
      <div class="d-flex flex-column flex-lg-row lg-justify-content-start">
        <button
          class="btn btn-danger"
          data-track-elem="button"
          data-track-name="Continue"
          (click)="accept()"
          [attr.aria-label]="convert('sellModule.offers.accept.ariaLabelContinueAcceptOffer')"
          >
          {{convert('common.btnContinue')}}
        </button>

        <button
          class="ms-lg-2 mt-3 mt-lg-0 btn"
          type="button"
          [ngClass]="'btn btn-link'"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          (click)="close()"
          [attr.aria-label]="convert('sellModule.offers.accept.ariaLabelCancelAcceptOffer')"
          >
          {{convert('common.btnCancel')}}
        </button>
      </div>
    </div>

    <div class="modal-close-container">
      <button
        class="modal__close"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="close()"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close"
        >
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </app-modal>
</ng-container>
